export class Patient {
	prenom: string | undefined;
	nomFamille: string | undefined;
	nomUsage: string | undefined;
	isFeminin: boolean = false;
	dateNaissance: string | undefined;
	assure: boolean = false;
	nir: string | undefined;
	patientStatus: string | undefined;
}

export interface PatientState {
	patient?: Patient;
}
